import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Login from './modulos/login/Login';
import Diseno from './comun/Diseno';
import ListaUsuarios from './modulos/usuarios/ListaUsuarios';
import ServicePlaceholder from './components/ServicePlaceholder';
import PanelFastFood from './modulos/fast-food/PanelFastFood';
import Inventario from './modulos/fast-food/Inventario';
import Bodega from './modulos/fast-food/Bodega';
import Mezclas from './modulos/fast-food/Mezclas';
import Ordenes from './modulos/fast-food/Ordenes';
import Clientes from './modulos/fast-food/Clientes';
import Reportes from './modulos/fast-food/Reportes';
import PuntosVenta from './modulos/fast-food/PuntosVenta';
import TasaDeCambio from './modulos/fast-food/TasaDeCambio';
import PanelCaja from './modulos/fast-food/Caja/PanelCaja';
import Impresoras from './modulos/fast-food/Impresoras';
import Promociones from './modulos/fast-food/Promociones';
import Gastos from './modulos/fast-food/Gastos';
import Toppings from './modulos/fast-food/Toppings';
import Variables from './modulos/fast-food/Variables';
import ReportesPeriodicos from './modulos/fast-food/ReportesPeriodicos';
import FacturacionSRI from './modulos/fast-food/FacturacionSRI';
import PanelCobranzas from './modulos/cobranzas/PanelCobranzas';
import ConfiguracionSecuencia from './modulos/fast-food/ConfiguracionSecuencia';
import PuntosPublico from './modulos/publico/PuntosPublico';
import Puntos from './modulos/fast-food/puntos/Puntos';
import Inicio from './modulos/inicio/Inicio';
import './App.css';

// Componente para proteger rutas
const PrivateRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div>Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  return <Diseno>{children}</Diseno>;
};

const FastFoodRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;

  // Usamos el diseño general para todos, la barra lateral filtrará los items
  return <Diseno>{children}</Diseno>;
};

// Componente para proteger la ruta de Cobranzas (Solo GESTOR_COBRANZAS)
const GestorCobranzasRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <div>Cargando...</div>;
  if (!user) return <Navigate to="/login" />;
  if (user?.role_details?.name !== 'GESTOR_COBRANZAS') {
    return <Navigate to="/fast-food/pos" />;
  }

  return <Diseno>{children}</Diseno>;
};

// Dashboard simple
const Dashboard = () => {
  const { user } = useContext(AuthContext);
  const roleName = user?.role_details?.name;
  
  if (roleName === 'GESTOR_COBRANZAS') {
      return <Navigate to="/cobranzas" />;
  }

  if (roleName !== 'SUPER_ADMIN' && !user?.is_superuser) {
      return <Navigate to="/fast-food/pos" />;
  }

  return <Inicio />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* Página pública de puntos de fidelidad (sin login) */}
          <Route path="/" element={<PuntosPublico />} />

          <Route path="/inicio" element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } />

          <Route path="/users" element={
            <PrivateRoute>
              <ListaUsuarios />
            </PrivateRoute>
          } />

          {/* Rutas de creación/edición eliminadas porque ahora son Modales */}

          <Route path="/fast-food" element={
            <FastFoodRoute>
              <PanelFastFood />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/puntos" element={
            <FastFoodRoute>
              <Puntos />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/inventory" element={
            <FastFoodRoute>
              <Inventario />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/toppings" element={
            <FastFoodRoute>
              <Toppings />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/variables" element={
            <FastFoodRoute>
              <Variables />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/promotions" element={
            <FastFoodRoute>
              <Promociones />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/bodega" element={
            <FastFoodRoute>
              <Bodega />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/mezclas" element={
            <FastFoodRoute>
              <Mezclas />
            </FastFoodRoute>
          } />
          {/* key: al cambiar de sección se reinicia la pantalla (búsqueda, página y selección) */}
          <Route path="/fast-food/orders" element={
            <FastFoodRoute>
              <Ordenes key="caja" />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/feria-orders" element={
            <FastFoodRoute>
              <Ordenes key="feria" isFeriaMode={true} />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/customers" element={
            <FastFoodRoute>
              <Clientes />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/reports" element={
            <FastFoodRoute>
              <Reportes />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/periodic-reports" element={
            <FastFoodRoute>
              <ReportesPeriodicos />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/pos" element={
            <FastFoodRoute>
              <PuntosVenta />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/tasa-cambio" element={
            <FastFoodRoute>
              <TasaDeCambio />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/shift" element={
            <FastFoodRoute>
              <PanelCaja />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/feria-shift" element={
            <FastFoodRoute>
              <PanelCaja isFeriaMode={true} />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/gastos" element={
            <FastFoodRoute>
              <Gastos />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/facturacion-sri" element={
            <FastFoodRoute>
              <FacturacionSRI />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/printers" element={
            <FastFoodRoute>
              <Impresoras />
            </FastFoodRoute>
          } />
          <Route path="/fast-food/secuencia" element={
            <FastFoodRoute>
              <ConfiguracionSecuencia />
            </FastFoodRoute>
          } />


          <Route path="/cobranzas" element={
            <GestorCobranzasRoute>
              <PanelCobranzas />
            </GestorCobranzasRoute>
          } />

          <Route path="/hotel" element={
            <PrivateRoute>
              <ServicePlaceholder title="Hotel" />
            </PrivateRoute>
          } />

          <Route path="/pool" element={
            <PrivateRoute>
              <ServicePlaceholder title="Piscinas" />
            </PrivateRoute>
          } />

          <Route path="/restaurant" element={
            <PrivateRoute>
              <ServicePlaceholder title="Restaurante" />
            </PrivateRoute>
          } />

          {/* Redirigir cualquier otra ruta al inicio */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
